module.exports = __webpack_public_path__ + "static/media/FindOnGithubLogo.ab793acf.svg";